import axios from 'axios'

export const csrfToken = () => {
  if (document) {
    const tokenTag = document.getElementsByName('csrf-token')
    if (tokenTag.length == 1) {
      return tokenTag[0].getAttribute('content')
    }
  }
  return ''
}

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.common['X-CSRF-Token'] = csrfToken()



// WEBPACK FOOTER //
// ./frontend/src/plugins/axios.js